import React, { CSSProperties } from "react";
import { lightInspectorTheme } from "./inspectorTheme";

export function StateInspectorButton({
  children,
  onClick,
  style,
  theme,
  disabled,
}: {
  children: React.ReactNode;
  onClick: () => void;
  style?: CSSProperties;
  theme: typeof lightInspectorTheme;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
      style={{
        flex: "0",
        appearance: "none",
        background: "none",
        color: theme.BASE_COLOR,
        opacity: disabled ? 0.25 : 1,
        border: "none",
        fontSize: "12px",
        whiteSpace: "nowrap",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0",
        cursor: "pointer",
        ...style,
      }}
    >
      {children}
    </button>
  );
}
